// src/components/landing/ContactSection.jsx
import React, { useState } from 'react';
import { Box, Typography, Grid, TextField, Button, MenuItem, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { consultationRequestAPI } from '../../services/api';
import { toast } from 'react-toastify';
import img_contact_kerala from '../../assets/images/landing/contact-kerala.jpg';
const contactKerala = img_contact_kerala;

const DISTRICTS = ['Thiruvananthapuram','Kollam','Pathanamthitta','Alappuzha','Kottayam','Idukki','Ernakulam','Thrissur','Palakkad','Malappuram','Kozhikode','Wayanad','Kannur','Kasargod'];

const inputSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#f8faff',
    borderRadius: 2.5,
    color: '#1e293b',
    '& fieldset': { borderColor: '#e2eaf5' },
    '&:hover fieldset': { borderColor: '#93c5fd' },
    '&.Mui-focused fieldset': { borderColor: '#1d6cf0' },
  },
  '& .MuiInputLabel-root': { color: '#64748b' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#1d6cf0' },
  '& .MuiSelect-icon': { color: '#64748b' },
};

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', district: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await consultationRequestAPI.create(form);
      toast.success('Request submitted! We will contact you soon.');
      setForm({ name: '', email: '', phone: '', district: '' });
    } catch {
      toast.error('Failed to submit. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box id="contact" sx={{ bgcolor: '#f8faff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Grid container spacing={8} sx={{ maxWidth: 1000, mx: 'auto' }} alignItems="flex-start">
        <Grid item xs={12} md={6}>
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1.5 }}>
              Contact Us
            </Typography>
            <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.3rem' }, fontWeight: 900, color: '#1e293b', mb: 3, lineHeight: 1.2 }}>
              Start Your Journey Today
            </Typography>
            <Box sx={{ width: '100%', height: 220, borderRadius: 4, overflow: 'hidden', mb: 3.5, border: '1px solid #e2eaf5', boxShadow: '0 8px 30px rgba(29,108,240,0.1)' }}>
              <Box component="img" src={contactKerala} alt="BSS IT Mission center"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Box>
            <Typography sx={{ color: '#64748b', fontSize: '0.92rem', lineHeight: 1.75, mb: 3.5 }}>
              Request a free consultation. We'll help you pick the right course and nearest center in your district.
            </Typography>
            {[
              { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1d6cf0" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>, text: 'Kerala, India — All 14 Districts' },
              { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1d6cf0" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.27a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>, text: '0471-2335853, 9188225979' },
              { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1d6cf0" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, text: 'bssitm@gmail.com' },
            ].map(({ icon, text }) => (
              <Box key={text} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.75 }}>
                <Box sx={{ width: 36, height: 36, bgcolor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {icon}
                </Box>
                <Typography sx={{ color: '#475569', fontSize: '0.88rem' }}>{text}</Typography>
              </Box>
            ))}
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.15 }}>
            <Box component="form" onSubmit={handleSubmit} sx={{
              bgcolor: '#fff', border: '1px solid #e2eaf5',
              borderRadius: 5.5, p: { xs: 3, md: 4.5 },
              boxShadow: '0 8px 40px rgba(29,108,240,0.10)',
            }}>
              <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: '#1e293b', mb: 3 }}>
                Request Free Consultation
              </Typography>
              <TextField fullWidth label="Your Full Name" name="name" value={form.name} onChange={handleChange} required sx={{ ...inputSx, mb: 2 }} />
              <TextField fullWidth label="Email Address" name="email" type="email" value={form.email} onChange={handleChange} required sx={{ ...inputSx, mb: 2 }} />
              <TextField fullWidth label="Phone Number" name="phone" value={form.phone} onChange={handleChange} required sx={{ ...inputSx, mb: 2 }} />
              <TextField select fullWidth label="Select District" name="district" value={form.district} onChange={handleChange} required sx={{ ...inputSx, mb: 3 }}
                SelectProps={{ MenuProps: { PaperProps: { sx: { bgcolor: '#fff', color: '#1e293b' } } } }}>
                {DISTRICTS.map((d) => <MenuItem key={d} value={d}>{d}</MenuItem>)}
              </TextField>
              <Button type="submit" fullWidth variant="contained" disabled={loading} sx={{
                background: 'linear-gradient(135deg,#1d6cf0,#0ea5e9)', borderRadius: 2.5,
                py: 1.75, fontSize: '0.95rem', fontWeight: 700, textTransform: 'none',
                boxShadow: '0 6px 20px rgba(29,108,240,0.35)',
              }}>
                {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Submit Request →'}
              </Button>
            </Box>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
}
